/* This file was created automatically, don't change it manually. */

import React, { forwardRef } from 'react';

import { ColorlessIconProps } from '../../types';
import { SVGContainer } from '../../SVGContainer';

const IconInfoFilled12 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconInfoFilled12(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 12 12" ref={ref}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M6 0a6 6 0 1 1 0 12A6 6 0 0 1 6 0Zm0 4.002c.568 0 1-.41 1-1 0-.59-.432-1-1-1-.568 0-1 .41-1 1 0 .59.432 1 1 1Zm0 1a1 1 0 0 0-1 1v3a1 1 0 1 0 2 0v-3a1 1 0 0 0-1-1Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconInfoFilled16 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconInfoFilled16(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 16 16" ref={ref}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0ZM7 7.123a.99.99 0 0 1 1-.98c.552 0 1 .438 1 .98v4.899a.99.99 0 0 1-1 .98.99.99 0 0 1-1-.98V7.123Zm2.14-3.136c0 .672-.492 1.14-1.14 1.14-.648 0-1.14-.468-1.14-1.14 0-.672.492-1.14 1.14-1.14.648 0 1.14.468 1.14 1.14Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconInfoFilled20 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconInfoFilled20(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 20 20" ref={ref}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M10 20c5.523 0 10-4.477 10-10S15.523 0 10 0 0 4.477 0 10s4.477 10 10 10ZM8.867 4.983a1.133 1.133 0 1 1 2.266 0 1.133 1.133 0 0 1-2.266 0ZM9 8.183a1 1 0 0 1 2 0v6.75a1 1 0 1 1-2 0v-6.75Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconInfoFilled24 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconInfoFilled24(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 24 24" ref={ref}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10ZM10.867 6.983a1.133 1.133 0 1 1 2.266 0 1.133 1.133 0 0 1-2.266 0Zm.133 3.2a1 1 0 0 1 2 0v6.75a1 1 0 1 1-2 0v-6.75Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

export const IconInfoFilled = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconInfoFilled(props, ref) {
    const { size = '16', role = 'supplementary' } = props;

    const iconProps = {
        ...props,
        size,
        ref,
        role,
        colorless: true,
    } as const;

    switch (size) {
        case '12':
            return <IconInfoFilled12 {...iconProps} />;
        case '16':
            return <IconInfoFilled16 {...iconProps} />;
        case '20':
            return <IconInfoFilled20 {...iconProps} />;
        case '24':
            return <IconInfoFilled24 {...iconProps} />;
        default:
            return <IconInfoFilled24 {...iconProps} />;
    }
});
